<script setup></script>

<template>
  <img
    src="@/assets/images/icons/post-ch.png"
    srcset="@/assets/images/icons/post-ch.png"
    :alt="$t('logisticpartners.post-ch')"
  />
</template>
